import store from "@/store"

export default function isDentalClinic({ next, router }) {
    if(!store || !store.getters.isDentalClinic) {
        router.push('/')
        return
    }
    return next()
}
